import { useUserContext, UserPermission } from "@/contexts/user";
import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { ConditionalRoute } from "./ConditionalRoute";

type AuthenticatedRouteProps = {
    children: ReactNode;
    requiredPermissions?: Iterable<UserPermission>;
};

export function AuthenticatedRoute({ children, requiredPermissions }: AuthenticatedRouteProps) {
    const { user, authReady, permissions, permissionsReady } = useUserContext();
    const location = useLocation();

    const permissionList = requiredPermissions ? [...requiredPermissions] : [];
    const needsPermissionCheck = permissionList.length > 0;

    // Auth gate — redirect to login if not authenticated
    if (!authReady) return "Loading...";
    if (!user) return <ConditionalRoute
        condition={false}
        redirect={`/login?redirectTo=${location.pathname}`}
    >{children}</ConditionalRoute>;

    // Permission gate — wait for permissions to load, then check
    if (needsPermissionCheck) {
        if (!permissionsReady) return "Loading...";
        const missingPermission = permissionList.some(p => !permissions.has(p));
        if (missingPermission) {
            return (
                <div className="flex flex-col items-center justify-center h-full gap-3 text-center p-8">
                    <p className="text-lg font-semibold">Du har inte behörighet att besöka den här sidan.</p>
                    <p className="text-muted-foreground">
                        Kontakta en administratör om du tror att det är ett misstag.
                    </p>
                </div>
            );
        }
    }

    return <>{children}</>;
}
